import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "quill/dist/quill.snow.css";
import React, { useState, useEffect } from "react";
import { PrimeReactProvider } from "primereact/api";
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { io } from "socket.io-client";
import Layout from "./components/Layout";

// ✅ Import all your pages
import MainDash from "./pages/MainDash/MainDash";
import ProductAdd from "./pages/Product/ProductAdd";
import ProductSearch from "./pages/Product/ProductSearch";
import Price from "./pages/Product/Price";
import CatSearch from "./pages/category/CatSearch";
import CatAdd from "./pages/category/CatAdd";
import SubcatSearch from "./pages/subcat/SubcatSearch";
import SubcatAdd from "./pages/subcat/SubcatAdd";
import Report from "./components/Report";
import Banner from "./components/Banner";
import Feedback1 from "./pages/feedback/feedback1";
import UserFeedback from "./pages/feedback/userfeedbacks";
import OrderDetails from "./pages/Order/OrderDetails";
import Dinein from "./pages/Order/Dine-in";
import OrderDetailPage from "./pages/Order/OrderDetailPage";
import DownloadOrdersPage from "./pages/Order/DownloadOrdersPage";
import ChangePassword from "./pages/Auth/ChangePassword";
import Login from "./pages/Auth/Login";
import RegisterResturant from "./pages/Resturant/AddResturant";
import RestaurantData from "./pages/Resturant/ResturantDetails";
import InventorySearch from "./pages/inventory/InventorySearch";
import InventoryAdd from "./pages/inventory/InventoryAdd";

const SOCKET_URL = process.env.REACT_APP_API_BASE;
const publicVapidKey = process.env.REACT_APP_PUBLIC_VAPID_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}
async function subscribeToPush() {
  try {
    if ("serviceWorker" in navigator && "PushManager" in window) {
      const registration = await navigator.serviceWorker.register("/sw.js");
      // console.log("✅ Service Worker Registered:", registration);

      const activeRegistration = await navigator.serviceWorker.ready;
      // console.log("🟢 Service Worker Active:", activeRegistration);

      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        console.warn("⚠️ Notification permission not granted");
        return;
      }

      const subscription = await activeRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
      });

      const response = await fetch(`${process.env.REACT_APP_API_BASE}/api/notifications/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(subscription),
      });

      if (response.ok) {
        // console.log("🔔 Push subscribed successfully!");
      } else {
        console.error("❌ Failed to save subscription:", response.statusText);
      }
    } else {
      console.warn("⚠️ Push messaging not supported in this browser");
    }
  } catch (err) {
    console.error("❌ Error during push subscription:", err);
  }
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token")
  );
  const username = localStorage.getItem("username");
  const navigate = useNavigate();

  // ✅ Global Socket Setup
  useEffect(() => {
    const socket = io(SOCKET_URL);

    socket.on("connect", () => console.log("✅ Connected to socket server"));

    socket.on("new-order", (order) => {
      toast.info(`🛒 New order received: ${order.orderId || "Check Orders"}`, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
      });
    });

    return () => socket.disconnect();
  }, []);

  const handleLoginSuccess = (token) => {
    setIsAuthenticated(true);
    localStorage.setItem("token", token);
    navigate("/dashboard");
  };

      useEffect(() => {
    if (isAuthenticated) {
      subscribeToPush();
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return (
      <>
        <ToastContainer />
        <Routes>
          <Route
            path="/"
            element={<Login onLoginSuccess={handleLoginSuccess} />}
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </>
    );
  }

  return (
    <div className="App">
      <ToastContainer />
      <Routes>
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/dashboard" />} />

        {/* Dashboard */}
        <Route
          path="/dashboard"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <MainDash username={username} />
            </Layout>
          }
        />

        {/* Product Management */}
        <Route
          path="/product"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <ProductSearch />
            </Layout>
          }
        />
        <Route
          path="/product/add"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <ProductAdd />
            </Layout>
          }
        />
        <Route
          path="/product/productdetail/:id"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <ProductAdd />
            </Layout>
          }
        />
        <Route
          path="/price-update"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <Price />
            </Layout>
          }
        />

        {/* Category Management */}
        <Route
          path="/categories"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <CatSearch />
            </Layout>
          }
        />
        <Route
          path="/add-category"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <CatAdd />
            </Layout>
          }
        />
        <Route
          path="/subcategories"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <SubcatSearch />
            </Layout>
          }
        />
        <Route
          path="/add-subcategory"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <SubcatAdd />
            </Layout>
          }
        />

        {/* Feedback & User Feedback */}
        <Route
          path="/userfeedback"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <UserFeedback />
            </Layout>
          }
        />
        <Route
          path="/feedback1"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <Feedback1 />
            </Layout>
          }
        />

        {/* Orders */}
        <Route
          path="/order"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <OrderDetails />
            </Layout>
          }
        />
        <Route
          path="/order/:id"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <OrderDetailPage />
            </Layout>
          }
        />
        <Route
          path="/dining"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <Dinein />
            </Layout>
          }
        />
        <Route
          path="/download-orders"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <DownloadOrdersPage />
            </Layout>
          }
        />

        {/* Restaurant Management */}
        <Route
          path="/resturant/add"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <RegisterResturant />
            </Layout>
          }
        />
        <Route
          path="/resturant/details"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <RestaurantData />
            </Layout>
          }
        />
        <Route
          path="/resturant/edit/:restaurantId"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <RegisterResturant />
            </Layout>
          }
        />

        {/* Inventory */}
        <Route
          path="/inventory"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <InventorySearch />
            </Layout>
          }
        />
        <Route
          path="/inventory/addstock"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <InventoryAdd />
            </Layout>
          }
        />
        <Route
          path="/inventory/batchdetails/:id"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <InventoryAdd />
            </Layout>
          }
        />

        {/* Reports */}
        <Route
          path="/reports"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <Report />
            </Layout>
          }
        />

        {/* Banner */}
        <Route
          path="/banner"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <Banner />
            </Layout>
          }
        />

        {/* Change Password */}
        <Route
          path="/change-password"
          element={
            <Layout setIsAuthenticated={setIsAuthenticated}>
              <ChangePassword />
            </Layout>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </div>
  );
}

function AppWrapper() {
  return (
    <BrowserRouter>
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>
    </BrowserRouter>
  );
}

export default AppWrapper;
